import React from "react";
import { Link, NavLink } from "react-router-dom";

import Cookies from "./Cookies";

import "../styles/components/Footer.css";

import logoV1RAGEdark from "../assets/images/icons/svg/logoV1RAGEdark.svg";
import fbLogo from "../assets/images/icons/svg/fb-grey.svg";
// import ytLogo from "../assets/images/icons/svg/yt-grey.svg";
// import twLogo from "../assets/images/icons/svg/tw-grey.svg";
import instaLogo from "../assets/images/icons/svg/insta-grey.svg";

const Footer = props => {
  if (props.mobileHide) {
    return null;
  }

  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="footer col-12">
            <div>
              <Link className="footer-logo" to="/">
                <img src={logoV1RAGEdark} alt="V1RAGE logo" />
              </Link>
            </div>
            <ul className="footer-menu" role="navigation">
              <li>
                <NavLink
                  className="title"
                  activeClassName="active"
                  to="/o-marce"
                >
                  O nas
                </NavLink>
              </li>
              <li>
                <NavLink className="title" activeClassName="active" to="/faq">
                  Faq
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="title"
                  activeClassName="active"
                  to="/regulamin"
                >
                  Regulamin
                </NavLink>
              </li>
              {/* <li>
                <NavLink className="title" activeClassName="active" to="/blog">
                  Nasz blog
                </NavLink>
              </li> */}
            </ul>
            <div className="social-icons footer-social-icons">
              <ul>
                <li>
                  <a
                    href="https://www.facebook.com/v1rage/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="svg"
                      style={{ display: "none" }}
                      src={fbLogo}
                      alt="Facebook logo white"
                    />
                  </a>
                </li>
                {/* <li>
                  <a href="https://www.facebook.com/?ref=logo" target="_blank" rel="noopener noreferrer">
                    <img className="svg" style={{display: 'none'}} src={ytLogo} alt="Youtube logo white" />
                  </a>
                </li>
                <li>
                  <a href="https://www.facebook.com/?ref=logo" target="_blank" rel="noopener noreferrer">
                    <img className="svg" style={{display: 'none'}} src={twLogo} alt="Twitter logo white" />
                  </a>
                </li> */}
                <li>
                  <a
                    href="https://www.instagram.com/v1ragecom/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="svg"
                      style={{ display: "none" }}
                      src={instaLogo}
                      alt="Instagram logo white"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="copyright col-12">Copyright © 2018 V1RAGE</div>
        </div>
      </div>
      <Cookies />
    </footer>
  );
};

export default Footer;
